import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import TYPES from '../../../config/Types'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import { IConvo } from '../../../model/convo'
import { Meta } from '../../../model/meta'
import { IUser, UserMeta } from '../../../model/user'
import userStore from '../../user/user-store'

export default async function fetchCreator (context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
  convoUtils.convoService.getCreator(convo).then((creator: IUser) => {
    // console.log('setting num likes for index: ' + i + ': ' + numLikes.value)
    if (creator.id) {
      if (!userStore.state.users.has(creator.id)) {
        console.log('setting user in map: %j', creator)
        creator.meta = new UserMeta()
        userStore.commitSetUser({ user: creator })
        userStore.dispatchSetMeta(creator)
      }
      console.log('setting creatpr in convo: %j', userStore.state.users.get(creator.id))
      convoStore.commitSetCreator({ convo: convo, creator: userStore.state.users.get(creator.id) as IUser })
    }
  })

  return
}
